export default "__VITE_ASSET__BE$dJgu6__"